/**
 * 地図出力に含める地番ポリゴン（選択中の物件・クリックした地番の強調表示）を
 * 識別するためのクラス名。Leaflet のデフォルト SVG レンダラーは全ベクターを
 * overlayPane の単一 svg に描くため、path 単位で出力可否を判定する必要がある。
 * LeafletMap 側で対象 Polygon の pathOptions.className に指定する。
 *
 * NOTE: 依存を持たない定数モジュールとして分離している。
 *       mapExportVisibility.ts は protomaps-leaflet に依存するモジュールを
 *       import しており、テストから定数だけ参照したい場合に重い依存が
 *       連鎖するのを避けるため。
 */
export const MAP_EXPORT_PARCEL_POLYGON_CLASS = "map-export-parcel-polygon";
